import React from 'react';
import CXBuilderTelco from './components/CXBuilderTelco';

function App() {
  return <CXBuilderTelco />;
}

export default App;
